export const PHONECHANGEAPPROVALMANAGEMENT_FILE = 'PHONECHANGEAPPROVALMANAGEMENT_FILE';
// 更新
export const PHONECHANGEAPPROVALMANAGEMENT_UPDATE = 'PHONECHANGEAPPROVALMANAGEMENT_UPDATE';
